import { SelfServiceContext } from "core";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import getAnalyticTags from "@lib-shared/lib/get-analytics-tags";

const getAnalytics = (category: string) => {
  return getAnalyticTags({
    component_name: "in_page_nav",
    nav_item: "in_page_click",
    nav_text: category,
    target_page_url: location.href
  });
}

const Categories = observer(() => {
    const selfServiceContext = useContext(SelfServiceContext);
    const store = selfServiceContext.stores.inbox;
    const categories = store.categories;

    const selectCategory = (category?: string) => store.updateCategory(category);

    return <ul className="categories">
        <li className={!store.category ? "active" : ""}
            onClick={() => selectCategory(undefined)}
            {...getAnalytics("All")}>All</li>
        {categories.map((category, ix) => {
            return <li
                key={ix}
                onClick={() => selectCategory(category)}
                {...getAnalytics(category)}
                className={!!store.category && store.category === category ? "active" : ""}>{category}</li>;
        })}
    </ul>;
});

export default Categories;
